import { IBudget, IProposal, IAllProposalDetails } from '@opengov/stories-shared/types';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import React, { useMemo } from 'react';

import { IModalMessages, ISelectedProposalInfo } from '../../../../types';
import { styles } from './ReplaceBudgetProposalRow.styles';
import { getProposalDetails } from '../replaceBudgetProposalUtils';

export const ReplaceBudgetProposalRow = (props: {
  isLoadingProposals: boolean;
  mapReplacingProposal: { [key: string]: { proposalId: number; title: string } };
  budget: IBudget;
  proposalFieldsDetails: IAllProposalDetails;
  replacingproposalList: IProposal[];
  messages: IModalMessages;
  onChangeReplaceProposalSelection(proposal: IProposal, proposalId: number): void;
}): JSX.Element => {
  const {
    isLoadingProposals,
    budget,
    replacingproposalList,
    messages,
    mapReplacingProposal,
    proposalFieldsDetails,
    onChangeReplaceProposalSelection
  } = props;

  const proposalDetails: ISelectedProposalInfo[] = useMemo(
    () => getProposalDetails(budget, proposalFieldsDetails),
    [budget]
  );

  return (
    <>
      {proposalDetails?.map((proposal: ISelectedProposalInfo) => {
        const selectedValue = mapReplacingProposal[proposal.proposalId]
          ? replacingproposalList?.find((p) => p.id === mapReplacingProposal[proposal.proposalId].proposalId) ?? null
          : null;
        return (
          <Box key={proposal.id} sx={styles.newProposalHeader}>
            <Typography variant="body2" sx={styles.textBox}>
              {proposal.title}
            </Typography>
            <Typography variant="body2" sx={styles.replaceWith}>
              {messages.replaceWith}
            </Typography>
            <Box sx={styles.proposalListSelect}>
              <Autocomplete
                options={replacingproposalList ?? []}
                getOptionLabel={(option) => option.title}
                value={selectedValue}
                onChange={(_event, value) => onChangeReplaceProposalSelection(value, proposal.proposalId)}
                size="small"
                disablePortal
                loading={isLoadingProposals}
                renderOption={(props, option) => <li {...props}>{option.title}</li>}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={messages.replaceWith}
                    placeholder={messages.enterProposals}
                    inputProps={{ ...params.inputProps, className: 'no-format' }}
                  />
                )}
              />
            </Box>
          </Box>
        );
      })}
    </>
  );
};
